import { EyeIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

const icbLinkCell = (path: string) =>
  ({ getValue }: { getValue: () => string }) => {
    const code = getValue();
    return (
      <Link to={`${path}/${code}`} className="flex items-center gap-1">
        <EyeIcon size={14} />
        {code}
      </Link>
    );
  };

// ─── Industries (Level 1) ──────────────────────────────────────────────────────

export const industryColumnsGenerator = () => [
  {
    accessorKey: 'code',
    header: 'ICB Code',
    cell: icbLinkCell('/admin/stock-icb/industries'),
  },
  {
    accessorKey: 'name',
    header: 'Name',
    cell: ({ getValue }) => getValue() ?? '-',
  },
  {
    accessorKey: 'name_en',
    header: 'Name (EN)',
    cell: ({ getValue }) => getValue() || '-',
  },
  {
    accessorKey: 'updated_at',
    header: 'Updated At',
    cell: ({ getValue }) => getValue() ?? '-',
  },
];

// ─── SuperSectors (Level 2) ────────────────────────────────────────────────────

export const superSectorColumnsGenerator = () => [
  {
    accessorKey: 'code',
    header: 'ICB Code',
    cell: icbLinkCell('/admin/stock-icb/supersectors'),
  },
  {
    accessorKey: 'name',
    header: 'Name',
    cell: ({ getValue }) => getValue() ?? '-',
  },
  {
    accessorKey: 'name_en',
    header: 'Name (EN)',
    cell: ({ getValue }) => getValue() || '-',
  },
  {
    accessorKey: 'industry_code',
    header: 'Industry Code',
    cell: ({ getValue }) => getValue() ?? '-',
  },
  {
    accessorKey: 'updated_at',
    header: 'Updated At',
    cell: ({ getValue }) => getValue() ?? '-',
  },
];

// ─── Sectors (Level 3) ────────────────────────────────────────────────────────

export const sectorColumnsGenerator = () => [
  {
    accessorKey: 'code',
    header: 'ICB Code',
    cell: icbLinkCell('/admin/stock-icb/sectors'),
  },
  {
    accessorKey: 'name',
    header: 'Name',
    cell: ({ getValue }) => getValue() ?? '-',
  },
  {
    accessorKey: 'name_en',
    header: 'Name (EN)',
    cell: ({ getValue }) => getValue() || '-',
  },
  {
    accessorKey: 'supersector_code',
    header: 'SuperSector Code',
    cell: ({ getValue }) => getValue() ?? '-',
  },
  {
    accessorKey: 'updated_at',
    header: 'Updated At',
    cell: ({ getValue }) => getValue() ?? '-',
  },
];

// ─── SubSectors (Level 4) ─────────────────────────────────────────────────────

export const subSectorColumnsGenerator = () => [
  {
    accessorKey: 'code',
    header: 'ICB Code',
    cell: icbLinkCell('/admin/stock-icb/subsectors'),
  },
  {
    accessorKey: 'name',
    header: 'Name',
    cell: ({ getValue }) => getValue() ?? '-',
  },
  {
    accessorKey: 'name_en',
    header: 'Name (EN)',
    cell: ({ getValue }) => getValue() || '-',
  },
  {
    accessorKey: 'sector_code',
    header: 'Sector Code',
    cell: ({ getValue }) => getValue() ?? '-',
  },
  {
    accessorKey: 'updated_at',
    header: 'Updated At',
    cell: ({ getValue }) => getValue() ?? '-',
  },
];
